export default "__VITE_ASSET__lKZlknbC__"